/**
 * As colunas da tabela e o que cada uma esconde em tela estreita.
 *
 * A classe de visibilidade mora aqui, e não solta em cada `<th>` e `<td>`, porque cabeçalho e
 * célula têm de sumir JUNTOS: esconder só um desloca a tabela inteira dali para a direita, e o
 * defeito só aparece na largura exata em que a regra vale — ninguém vê isso revisando no
 * desktop. Com a constante compartilhada, as duas pontas mudam na mesma edição.
 */

/**
 * O que a lista está mostrando, dito uma vez só.
 *
 * Vira a `<caption>` da tabela e o nome da lista de cartões do celular — as duas formas da mesma
 * página de resultados. Quem usa leitor de tela ouve isto antes do primeiro registro, e é a
 * única pista de que a lista pode estar recortada.
 */
export const DESCRICAO_DA_LISTA = 'Solicitações de mudança que atendem aos filtros'

export interface Coluna {
  /** Identificador estável. Não é rótulo: renomear o cabeçalho não pode trocar a chave. */
  id: string
  titulo: string
  /** Classe de visibilidade, quando a coluna some em tela estreita. */
  classe?: string
}

/**
 * Some abaixo de `md`.
 *
 * Risco é a única coluna que, vazia, é a regra e não a exceção — fica "não avaliado" enquanto o
 * comitê não olhou. É a primeira a sair quando falta largura.
 */
export const SO_A_PARTIR_DE_MEDIA = 'hidden md:table-cell'

/**
 * Some abaixo de `lg`.
 *
 * Sistema e solicitante são contexto, não identificação: quem procura uma solicitação a acha
 * pelo código ou pelo chamado. Os dois continuam no cartão do celular e no detalhe, então
 * escondê-los aqui tira ruído sem tirar informação de lugar nenhum.
 */
export const SO_A_PARTIR_DE_LARGA = 'hidden lg:table-cell'

export const COLUNAS: Coluna[] = [
  { id: 'codigo', titulo: 'Código' },
  { id: 'chamado', titulo: 'Chamado' },
  { id: 'sistema', titulo: 'Sistema', classe: SO_A_PARTIR_DE_LARGA },
  { id: 'estado', titulo: 'Estado' },
  { id: 'prioridade', titulo: 'Prioridade' },
  { id: 'risco', titulo: 'Risco', classe: SO_A_PARTIR_DE_MEDIA },
  { id: 'solicitante', titulo: 'Solicitante', classe: SO_A_PARTIR_DE_LARGA },
  { id: 'criada', titulo: 'Criada em' },
]
